/* ==========================================================================
   ProductCardLeiRxjs > Client > Config
   ========================================================================== */

/* Import modules */

/* Config */
const config = {
    component: 'ProductCardLeiRxjs',
    init: true,
    start: true,
    tabsSameHeight: false,
    css: {
        base: 'product-card-lei-rxjs',
        price: 'product-card-lei-rxjs__price',
        active: 'is-active'
    },
    type: {
        tooltip: 'product-card-lei-rxjs-tooltip',
        image: 'product-card-lei-rxjs-image',
        secondaryImage: 'product-card-lei-rxjs-secondary-image',
        navButton: 'product-card-lei-rxjs-nav-button'
    },
    icons: {
        info: 'info',
        magnifier: 'magnifier',
        stars: 'star-filled',
        key: 'key'
    },
    iconBrand: {
        cir: 'earth-arrow',
        com: 'map-markers',
        rut: 'car-routes',
        hon: 'hearts',
        ter: 'marker-compass',
        lei: 'hot-air-balloon',
        dis: 'disney',
        ski: 'snow'
    },
    image: {
        alternative: '',
        resize: {
            width: 268,
            height: 145
        }
    },
    tooltip: {
        placement: 'bottom'
    }
};

module.exports = () => config;
